import { uniqueId } from "lodash";
import { DataTypeIdValue } from "../CharacteristicsTableConst/CharacteristicsTableConst";
import { CharacteristicValues } from "../CharacteristicsTableTypes";
import { store } from "../../../../..";

// Массив обязательных характеристик
export const getRequiredCharacteristics = ({
  isSelectedObjectId,
  isInheritableObject,
  objectTypeId,
}: {
  isSelectedObjectId?: boolean;
  isInheritableObject?: boolean;
  objectTypeId?: number;
}) => {
  const { characteristicDictionaries, objectCharTypes } = store.getState().characteristics;

  const findObjectCharTypes = objectCharTypes?.flatMap((el) =>
    el.objectTypeId === objectTypeId ? el : []
  );

  return findObjectCharTypes?.flatMap((characteristic) => {
    if (characteristic?.minCardinality && characteristic?.minCardinality >= 1) {
      let values: CharacteristicValues[] = [];

      if (characteristic?.defaultValue) {
        let id = Number(uniqueId());
        let value: CharacteristicValues["value"] = characteristic?.defaultValue;
        let valDicId: number | undefined;

        if (characteristic.charType.dataTypeId === DataTypeIdValue["Словарный термин"]) {
          const finDic = characteristicDictionaries?.find(
            (dic) =>
              dic?.dicType === characteristic?.charType?.valueDicTypeAlias ||
              dic?.data?.[0]?.dicTypeId === characteristic?.charType?.valueDicTypeId
          )?.data;

          if (finDic) {
            const findDicEl = finDic.find(
              (dicEl) => String(dicEl.id) === String(characteristic.defaultValue)
            );

            id = finDic && finDic?.length > 0 ? Number(findDicEl?.id) : Number(uniqueId());

            value = Number(findDicEl?.id);
            valDicId = Number(findDicEl?.id);
          }
        } else {
          id =
            characteristic.objectCharTypeValues && characteristic.objectCharTypeValues?.length > 0
              ? Number(
                  characteristic.objectCharTypeValues.find(
                    (charEl) => charEl.charTypeValue.value === characteristic.defaultValue
                  )?.id
                )
              : Number(uniqueId());
        }

        values = [
          {
            id,
            value,
            valDicId,
          },
        ];
      }

      return {
        key: `id=${characteristic?.id}_unicKey=${uniqueId()}`,
        isRequired: true,
        isNew: true,
        objectCharTypeId: characteristic.id,
        objectId: !isSelectedObjectId && isInheritableObject ? objectTypeId : undefined,
        values,
        characteristic,
      };
    }
    return [];
  });
};
